import React, { useEffect, useState } from 'react';
import { useListadoRecordado } from '../../components/useListadoRecordado';
import axios from '../../axiosConfig';
import Table from 'react-bootstrap/Table';
import { useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { Modal } from 'react-bootstrap';
import { useLoading } from '../../components/LoadingContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PaginationTable from '../../components/PaginationTable';  // Importa el componente de paginación
import { ResponsiveContainer,Line, LineChart,BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend,AreaChart,Area,Radar,RadarChart, PieChart, Cell, Pie, ComposedChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis } from 'recharts';
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { FaUserFriends, FaClock, FaBook,FaSync,FaSearch  } from 'react-icons/fa';  // Importamos íconos de react-icons
import ProgressBar from 'react-bootstrap/ProgressBar';
import { FaExpand, FaCompress } from 'react-icons/fa'; // Íconos para expandir/contraer
import { motion } from 'framer-motion';

const COLORS = ['#8884d8', '#82ca9d', '#ffc658', '#ff7300', '#00C49F', '#FFBB28'];

const ShowPartIniciativas = () => {
    const [datos, setDatos] = useState([]);

    // Página y filtros se recuerdan: al volver de Editar el listado queda donde estaba.
    // Va antes de indexOfLastItem, que ya usa currentPage.
    const { filters, setFilters, currentPage, setCurrentPage } = useListadoRecordado('part-iniciativas', {
        nivel_instruccion_id: '',
        genero_id: '',
        cedula_identidad: '' ,
        nombres:'',
        apellidos:'',
        edad_mayor:'',
        edad_menor:'',

    });
    const itemsPerPage = 8;
    const [showModal, setShowModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [loadingData, setLoadingData] = useState(false); // Estado para controlar la recarga
    const [totalPages, setTotalPages] = useState(1); // Default to 1 page initially
    const [statistics, setStatistics] = useState({});
    // Mueve esto al principio del componente

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const [nivelInstruccionOptions, setNivelInstruccionOptions] = useState([]);
    const [generoOptions, setGeneroOptions] = useState([]);
    const [estadoOptions, setEstadoOptions] = useState([]);
    const [SuperatecOptions, setSuperatecOptions] = useState([]);
    const [grupoPrioritarioOptions, setgrupoPrioritarioOptions] = useState([]);
    const dataToUse = datos;

    const totalParticipantes = statistics?.totalParticipantes || 0;
    const mayorEdad = statistics?.mayorEdad || 0;
    const menorEdad = statistics?.menorEdad || 0;
    const promedioEdad = statistics?.promedioEdad || 0;
    const porcentajeMasculino = statistics?.porcentajesGenero?.masculino || 0;
    const porcentajeFemenino = statistics?.porcentajesGenero?.femenino || 0;
    const porcentajeOtros = statistics?.porcentajesGenero?.otros || 0;
    const [showModalInfo, setShowModalInfo] = useState(false);
    const [mostrarSoloTabla, setMostrarSoloTabla] = useState(true);
    const [showModalPlantilla, setShowModalPlantilla] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [importError, setImportError] = useState(null); // <-- para importación
const [deleteError, setDeleteError] = useState(null); // <-- si deseas también capturar errores en eliminación



     const toggleTablaExpandida = () => {
        if (mostrarSoloTabla == true){
            getAllDatos();
        }
        setMostrarSoloTabla(prevState => !prevState);
        
    };
    

    const isActiveFilterValue = (v) => {
  if (v === null || v === undefined) return false;
  return String(v).trim() !== "";
};

 const activeFilterClass = (v) => (isActiveFilterValue(v) ? "is-active-filter" : "");
    
    const { setLoading } = useLoading();
    const [error, setError] = useState(null);
    const navigate = useNavigate();

   const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
};


    

    // Obtener el rol del usuario desde localStorage
    const userRole = localStorage.getItem('role'); // Puede ser 'admin', 'coordinador', 'invitado', etc.
    const handleShowModal = (id) => {
        setSelectedId(id);  // Almacena el ID del participante que se va a eliminar
        setShowModal(true); // Muestra el modal
    };
    
    const handleCloseModal = () => {
        setShowModal(false); // Cierra el modal
    };
    
 

    
    useEffect(() => {
        setLoading(true);
        getDatos (currentPage);
        fetchFilterOptions()
            .finally(() => setLoading(false));
    }, []); 
    
    
    
    const handlePageChange = (page) => {
        setCurrentPage(page);
        getDatos(page); // Llama a `getAllDatos` con el nuevo número de página
        
    };




    const getAllDatos = async (page = 1) => {
        // Buscar pasa el evento del clic como `page`: cualquier cosa que no sea
        // un número es la página 1. Y la página mostrada se fija aquí, así
        // coincide siempre con los datos (buscar, recargar, borrar, paginar).
        const pagina = Number.isInteger(page) && page > 0 ? page : 1;
        setCurrentPage(pagina);
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/part-iniciativas-filtrados`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { ...filters, page: pagina },
            });
            
            const estadisticas = response.data.estadisticas || {};
            estadisticas.rangoEdades = estadisticas.rangoEdades || [];
            
            setDatos(Array.isArray(response.data.datos.data) ? response.data.datos.data : []);
            setStatistics(estadisticas);
            setTotalPages(response.data.datos.last_page || 1); // Actualiza el total de páginas
            setLoading(false);
        } catch (error) {
            console.error('Error fetching data:', error);
            toast.error('Error fetching data');
            setDatos([]);
            setStatistics({ rangoEdades: [] });
        }
    };
       const getDatos = async (page = 1) => {
        // Igual que getAllDatos: página normalizada y fijada aquí.
        const pagina = Number.isInteger(page) && page > 0 ? page : 1;
        setCurrentPage(pagina);
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/part-iniciativas-filtrados-solos`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { ...filters, page: pagina },
            });
            
            const estadisticas = response.data.estadisticas || {};
            estadisticas.rangoEdades = estadisticas.rangoEdades || [];
            
            setDatos(Array.isArray(response.data.datos.data) ? response.data.datos.data : []);
            setTotalPages(response.data.datos.last_page || 1); // Actualiza el total de páginas
        } catch (error) {
            console.error('Error fetching data:', error);
            toast.error('Error fetching data');
            setDatos([]);
            setStatistics({ rangoEdades: [] });
        }
    };


    const fetchFilterOptions = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/filter-datos`, { headers: { Authorization: `Bearer ${token}` } });
            
            setNivelInstruccionOptions(response.data.nivel_instruccion);
            setGeneroOptions(response.data.genero);


    
        } catch (error) {
            setError('Error fetching filter options');
            console.error('Error fetching filter options:', error);
        }
    };


    const deleteDatos = async () => {
        const token = localStorage.getItem('token');
        try {
            await axios.delete(`/part-iniciativas/${selectedId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            toast.success('Participante eliminado con Éxito');             
            getDatos();
            setShowModal(false); // Cierra el modal tras la eliminación exitosa
        } catch (error) {
            setError('Error deleting data');
            console.error('Error deleting data:', error);
            toast.error('Error al eliminar Participante');
            setShowModal(false); // Cierra el modal tras el error
        }
    };
    




 const loadData = async () => {
        setLoadingData(true); // Inicia el estado de carga
        try {

        if (mostrarSoloTabla == true){
            getDatos();
            fetchFilterOptions();
        }
        else {getAllDatos();
            fetchFilterOptions()};
            
            
        } catch (error) {
            console.error('Error recargando los datos:', error); // Maneja el error si ocurre
        } finally {
            setLoadingData(false); // Detener el estado de carga cuando la solicitud haya terminado
        }
    };


    const printInfo = async (filters) => {
        try {
          const token = localStorage.getItem("token");
          if (!token) {
            alert("Token no encontrado.");
            return;
          }
      
          // Realizar la solicitud GET a la ruta que genera los datos en JSON
          const response = await axios.get(`/part-iniciativas-filtrados-print`, {
            headers: { Authorization: `Bearer ${token}` },
            params: filters, // Pasamos los filtros a la ruta
          });
      
          // Extraer los datos principales y las estadísticas
          const jsonData = response.data.datos; // Clave 'datos'
          const estadisticasData = response.data.estadisticas; // Clave 'estadisticas'
      
          if (!jsonData || jsonData.length === 0) {
            alert("No hay datos para exportar.");
            return;
          }
      
          // Convertir los datos principales a una hoja
          const worksheet1 = XLSX.utils.json_to_sheet(jsonData); // Hoja de datos
          const workbook = XLSX.utils.book_new(); // Crea un libro nuevo
          XLSX.utils.book_append_sheet(workbook, worksheet1, "Datos"); // Añade la hoja al libro
      // Preparar las estadísticas para convertirlas
        const estadisticasArray = [];

        // Iterar sobre las estadísticas y descomponerlas
        Object.entries(estadisticasData).forEach(([key, value]) => {
        if (typeof value === "object" && !Array.isArray(value)) {
            // Si el valor es un objeto, descomponer sus datos (por ejemplo, participantesPorEstado, nivelesInstruccion)
            Object.entries(value).forEach(([subKey, subValue]) => {
            if (typeof subValue === "object") {
                estadisticasArray.push({
                Estadística: `${key} - ${subKey}`,
                Cantidad: subValue.count || 0,
                Porcentaje: subValue.percentage ? `${subValue.percentage.toFixed(2)}%` : "0%",
                });
            } else {
                estadisticasArray.push({
                Estadística: `${key} - ${subKey}`,
                Valor: subValue,
                });
            }
            });
        } else {
            // Si es un valor simple, agregarlo directamente
            estadisticasArray.push({
            Estadística: key,
            Valor: value,
            });
        }
        });

        // Convertir las estadísticas a una hoja
        const worksheet2 = XLSX.utils.json_to_sheet(estadisticasArray);
        XLSX.utils.book_append_sheet(workbook, worksheet2, "Estadísticas"); // Añade la segunda hoja
                // Generar el archivo Excel
                const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
            
                // Crear un Blob y guardarlo como archivo
                const blob = new Blob([excelBuffer], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                saveAs(blob, "participantes_estadisticas.xlsx");
                } catch (error) {
                console.error("Error al generar el archivo Excel", error);
                alert("Hubo un error al generar el archivo Excel");
                }
            };
      
      

      const handlePrint = async () => {
        setShowModalInfo(false); // Cerrar el modal
        await printInfo(filters); // Llamar a la función de impresión con los filtros
      };
    



    
    const rangoEdades = statistics?.rangoEdades
    ? Object.entries(statistics.rangoEdades).map(([name, percentage]) => ({
        name,
        value: percentage,
    }))
    : [];





    const nivelesInstruccionData = statistics?.nivelesInstruccion
    ? Object.entries(statistics.nivelesInstruccion).map(([name, obj]) => ({
        name,
        count: obj.count,
    }))
    : [];




    const handleFileUpload = (file) => {
        setSelectedFile(file);
      };
      
      const handleSubmitImport = async () => {
        if (!selectedFile) return;
      
        const token = localStorage.getItem('token');
        const formData = new FormData();
        formData.append('file', selectedFile);
      
        try {
          const response = await axios.post('/import-participantes', formData, {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'multipart/form-data',
            },
          });
      
          if (response.data.duplicate_cedulas && response.data.duplicate_cedulas.length > 0) {
            setImportError(
              `Se importaron algunos participantes, pero las siguientes cédulas ya están registradas: ${response.data.duplicate_cedulas.join(', ')}.`
            );
            loadData(); // Recargar datos para mostrar los importados
          } else {
            loadData();
            toast.success("Archivo importado correctamente");
            setShowModalPlantilla(false);
          }
        } catch (error) {
          const rawMessage = error.response?.data?.message || '';
      
          // Detectar error general
          const matchGeneral = rawMessage.match(/^Error: /);
          if (matchGeneral) {
            setImportError(rawMessage);
          } else {
            setImportError('Ocurrió un error al importar los datos.');
          }
        }
      };
      




const handleDownloadPlantilla = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get('/plantilla-participantes', {
        responseType: 'blob',
        headers: { Authorization: `Bearer ${token}` },
      });
  
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'plantilla_participantes.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('Error al descargar plantilla:', error);
    }
  };
  
function calcularEdad(fechaNacimiento) {
  const hoy = new Date();
  const nacimiento = new Date(fechaNacimiento);
  let edad = hoy.getFullYear() - nacimiento.getFullYear();
  const mes = hoy.getMonth() - nacimiento.getMonth();

  if (mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate())) {
    edad--;
  }

  return edad;
}




 
    const columns = ["Id","Cédula", "Nombres", "Apellidos", "Email", "Teléfono","Edad", "Acciones"];


    const renderItem = (dato) => (
        <tr key={dato.id}>
            <td className="col">{dato.id}</td>
            <td className="col-cedulas">{dato.cedula_identidad}</td>
            <td className="col-nombress">{dato.nombres}</td>
            <td className="col-apellidoss">{dato.apellidos}</td>
            <td className="col">{dato.email}</td>
            <td className="col">{dato.tlf_casa}</td>
            <td className="col">
                {dato.fecha_nacimiento
                    ? calcularEdad(dato.fecha_nacimiento)
                    : 'Sin fecha'}
                </td>

            <td className="col-accioness">
                <div className="d-flex justify-content-around">
                <Button
                    variant="btn btn-info" 
                    onClick={() => navigate(`/part-iniciativas/${dato.id}`)}
                    className="me-2"
                    title="Ver más"
                >
                    <i className="bi bi-eye"></i>
                </Button>
                {/* <Button
                    variant="btn btn-info" 
                    onClick={() => navigate(`/datos/cursos/${dato.id}`)}
                    className="me-2"
                    title="Ver Unidades Curriculares del Participante"
                >
                    <i className="bi bi-book-fill"></i>
                </Button> */}
                    {userRole === 'admin' || userRole === 'coordinador' || userRole === 'corporativo' || userRole === 'servicio-corp'   ? (
                        <>
                            <Button
                                variant="btn btn-warning"
                                onClick={() => navigate(`/part-iniciativas/${dato.id}/edit`)}
                                className="me-2 icon-white"
                                title="Editar"
                            >
                                <i className="bi bi-pencil-fill"></i>
                            </Button>
                            {userRole === 'admin' && (
                                <Button
                                variant="btn btn-danger"
                                onClick={() => handleShowModal(dato.id)}
                                className="me-2"
                                title="Eliminar"
                                >
                                <i className="bi bi-trash3-fill"></i>
                                </Button>
                            )}
                        </>
                    ) : null}
                </div>
            </td>
        </tr>
    );
    
    

    return (
        
        <div className="container-fluid " style={{ fontSize: '0.85rem' }}>
            
            <motion.div 
                initial={{ opacity: 1, maxHeight: "500px" }} // Establece una altura máxima inicial
                animate={{
                    opacity: mostrarSoloTabla ? 0 : 1,
                    maxHeight: mostrarSoloTabla ? 0 : "500px", // Reduce la altura en transición
                }}
                transition={{ duration: 0.5, ease: "easeInOut" }} // Animación más fluida
                style={{ overflow: "hidden" }} // Evita que los elementos internos se muestren fuera de la caja
            >
            <div className="stat-box d-flex justify-content-between" style={{ maxWidth: '100%' }}> 
            
                {/* Total de Participantes */}
                <div className="stat-card" style={{ padding: '5px', margin: '0 10px', width: '22%' }}>
                    
                    <div className="stat-icon"><FaUserFriends /></div>
                    <div className="stat-number" style={{ color: '#58c765', fontSize: '1.8rem' }}>{totalParticipantes}</div>
                    <h4 style={{ fontSize: '1.1rem', color:'gray' }}>Total de Participantes</h4>
                </div>
                <div className="stat-card" style={{
                    padding: '8px',
                    margin: '0 10px',
                    width: '22%',
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                }}>

                    {/* Menor y Mayor Edad - Distribuidos a los lados */}
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',  // Distribuye menor a la izquierda y mayor a la derecha
                        fontSize: '0.8rem',  // Ajustamos el tamaño del texto
                        color: '#6c757d',
                        padding: '0 8px',  // Reducimos el padding para que esté más junto
                    }}>
                        <div style={{ color: '#5cb85c', fontWeight: 'bold' }}> {/* Color verde para menor */}
                            <span>↓ Menor:</span> {menorEdad} años
                        </div>
                        <div style={{ color: '#d9534f', fontWeight: 'bold' }}> {/* Color rojo para mayor */}
                            <span>↑ Mayor:</span> {mayorEdad} años
                        </div>
                    </div>

                    {/* Promedio de Edad */}
                    <div className="stat-number" style={{
                        color: '#ffda1f',  
                        fontSize: '1.7rem',  // Reducimos el tamaño de la fuente
                        fontWeight: 'bold',
                        textAlign: 'center',
                        marginBottom: '3px',  // Reducimos el margen
                    }}>
                        {promedioEdad.toFixed(0)} Años
                    </div>

                    <h4 style={{
                        fontSize: '0.9rem',  // Reducimos el tamaño del texto
                        color: '#6c757d',  
                        textAlign: 'center',
                        marginBottom: '6px',  // Reducimos el margen inferior
                    }}>
                        Promedio de Edad
                    </h4>

                    {/* Barra de Progreso */}
                    <div style={{ width: '75%', margin: '0 auto' }}>
                        <ProgressBar
                            now={(promedioEdad * 100) /mayorEdad} 
                            variant="warning"
                            style={{
                                height: '8px',  // Reducimos la altura de la barra
                                borderRadius: '5px',
                                backgroundColor: '#f1f1f1'
                            }}
                        />
                        
                    </div>
                    
                </div>
            



                
                <div className="stat-card" style={{ padding: '0', margin: '0 10px', width: '100%', maxWidth: '500px' }}> 
                    <ResponsiveContainer width="100%" height={120}> {/* Ajustamos el width y height dinámicamente */}
                        <PieChart>
                        <Pie
                            data={[
                            { name: 'Masculino', value: porcentajeMasculino },
                            { name: 'Femenino', value: porcentajeFemenino },
                            ]}
                            dataKey="value"
                            startAngle={180} // Semicírculo
                            endAngle={0}
                            cx="50%"        // Centrar horizontalmente con porcentaje
                            cy="70%"        // Ajustamos la gráfica para pegarla más arriba
                            outerRadius="100%" // Radio basado en el porcentaje del contenedor para mayor flexibilidad
                            fill="#8884d8"
                            label={({ name, value }) => ` ${value.toFixed(2)}%`} // Mostrar los porcentajes
                            labelLine={true}
                        >
                            {/* Colores para cada sector */}
                            <Cell key="Masculino" fill="#185da7" />
                            <Cell key="Femenino" fill="rgba(254, 185, 56, 0.9)" />
                        </Pie>
                        <Legend 
                            layout="horizontal" 
                            verticalAlign="bottom" 
                            align="center" 
                            wrapperStyle={{ 
                            width: "98%", 
                            textAlign: "center", 
                            fontSize: '10px' 
                            }}
                        />
                        
                        <Tooltip />
                        
                        </PieChart>
                        
                        
                    </ResponsiveContainer>
                    </div>




            </div>
           </motion.div>

          
                
            <div className="row" style={{ marginTop: '10px' }}>
                
            <motion.div
            initial={{ width: "100%" }}
            animate={{ width: mostrarSoloTabla ? "100%" : "100%" }}
            transition={{ duration: 0.5 }}
        >
            

                    <div className="card-box" style={{ padding: '10px' }}> {/* Reduce padding de la tabla */}
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h2 style={{ fontSize: '1.8rem' }}>Lista de Participantes Iniciativas</h2>
                            <div className="d-flex align-items-center">
                            <Button 
                                variant="info me-2" 
                                onClick={toggleTablaExpandida} 
                                style={{ padding: '5px 15px' }}
                                title={mostrarSoloTabla ? "Mostrar Todo" : "Modo Tabla Expandida"}
                            >
                                {mostrarSoloTabla ? <FaCompress /> : <FaExpand />}
                            </Button>

                           
                                    <Button
                                    variant="info me-2"
                                    onClick={loadData}
                                    disabled={loadingData} // Deshabilita el botón si está cargando
                                    style={{ padding: '5px 10px', width: '120px' }} // Ajusta padding y ancho
                                    title="Recargar datos"
                                >
                                    

                                    {/* Icono de recarga */}
                                    {loadingData ? (
                                    <FaSync className="spin" /> // Ícono girando si está cargando
                                    ) : (
                                    <FaSync />
                                    )}
                                </Button>

                                 <Button 
                                        variant="info me-2" 
                                        onClick={() => {
                                            if (mostrarSoloTabla === false) {
                                                getAllDatos();
                                            } else {
                                                getDatos();
                                            }
                                        }}
                                        style={{ padding: '5px 10px', width: '120px' }} 
                                        title="Buscar"
                                    >
                                        <FaSearch className="me-1" /> {/* Ícono de lupa */}
                                    </Button>
                                <Button
                                    variant="btn btn-info"
                                    onClick={() => setShowModalInfo(true)} // Abrir el modal
                                    className="me-2"
                                    title="Exportar en Excel"
                                >
                                    <i className="bi bi-printer-fill"></i> {/* Icono de impresora */}
                                </Button>
                                

                                <div className="d-flex gap-2">
                                {userRole === 'admin' || userRole === 'coordinador' || userRole === 'corporativo' || userRole === 'servicio-corp'  ? (

                                <Button variant="btn custom" onClick={() => navigate('/part-iniciativas/create')} className="btn-custom" title="Crear Participante">
                                <i className="bi bi-person-plus-fill me-2  "></i> Nuevo
                            </Button>

                                ):(
                                    
                                    <></>
                                )}

                                   
                                    </div>
                        </div>
                    </div>
                               <div className="d-flex gap-2 align-items-center mb-3">
                                 <Form.Control
                                type="text"
                                placeholder="Buscar por Cédula"
                                value={filters.cedula_identidad} // Conecta el campo de cédula al estado de filtros
                                name="cedula_identidad"
                                onChange={handleFilterChange} // Usa handleFilterChange para actualizar el valor
                                className={activeFilterClass(filters.cedula_identidad)}
                            />

                            <Form.Control
                                type="text"
                                placeholder="Buscar por Nombre"
                                value={filters.nombres} // Conecta el campo de cédula al estado de filtros
                                name="nombres"
                                onChange={handleFilterChange} // Usa handleFilterChange para actualizar el valor
                                className={activeFilterClass(filters.nombres)}
                            />
                            <Form.Control
                                type="text"
                                placeholder="Buscar por Apellido"
                                value={filters.apellidos} // Conecta el campo de cédula al estado de filtros
                                name="apellidos"
                                onChange={handleFilterChange} // Usa handleFilterChange para actualizar el valor
                                className={activeFilterClass(filters.apellidos)}
                            />
                                </div>          
                        {/* Filtros */}
                        <div className="d-flex mb-3 ">
                        <Form.Select
                                name="nivel_instruccion_id"
                                value={filters.nivel_instruccion_id}
                                onChange={handleFilterChange}
                                className={activeFilterClass(filters.nivel_instruccion_id)}
                            >
                                <option value="">Nivel de Instrucción</option>
                                {nivelInstruccionOptions?.map(option => (
                                    <option key={option.id} value={option.id}>{option.descripcion}</option>
                                ))}

                            </Form.Select>

                            <Form.Select
                                name="genero_id"
                                value={filters.genero_id}
                                onChange={handleFilterChange}
                                className={activeFilterClass(filters.genero_id)}
                            >
                                <option value="">Género</option>
                                {generoOptions.map(option => (
                                    <option key={option.id} value={option.id}>{option.descripcion}</option>
                                ))}
                            </Form.Select>
                          
                           
                        </div>
                        <div className="d-flex mb-3 ">
                            <Form.Control
                                    type="number"
                                    placeholder="Edad mayor que"
                                    value={filters.edad_mayor} // Conecta el campo de cédula al estado de filtros
                                    name="edad_mayor"
                                    onChange={handleFilterChange} // Usa handleFilterChange para actualizar el valor
                                    className={activeFilterClass(filters.edad_mayor)}
                                />

                            <Form.Control
                                    type="number"
                                    placeholder="Edad menor que"
                                    value={filters.edad_menor} // Conecta el campo de cédula al estado de filtros
                                    name="edad_menor"
                                    onChange={handleFilterChange} // Usa handleFilterChange para actualizar el valor
                                    className={activeFilterClass(filters.edad_menor)}
                                />  

                                </div>
                             
                              
                                
                        
                       
                        <PaginationTable
                            data={datos}
                            itemsPerPage={itemsPerPage}
                            columns={columns}
                            renderItem={renderItem}
                            currentPage={currentPage}
                            onPageChange={handlePageChange}
                            totalPages={totalPages}  // <--- Añade esta línea si aún no está
                        />


                       
                        <ToastContainer />
                    </div>
                    </motion.div>
            
            </div>
            
            {/* Gráfica  justo debajo de la tabla */}
           
            <motion.div 
            initial={{ opacity: 1, height: "auto" }}
            animate={{ opacity: mostrarSoloTabla ? 0 : 1, height: mostrarSoloTabla ? 0 : "auto" }}
            transition={{ duration: 0.5 }}
        >
            <div className="col-lg-12 d-flex justify-content-between" style={{ gap: '20px' }}>


                <div className="chart-box" style={{ flex: '1 1 45%', maxWidth: '45%', marginRight: '10px'}}>

                <   h4 style={{ fontSize: '1.2rem' }}>Rango de edad</h4>
                              <ResponsiveContainer width="100%" height={300} >
                        <PieChart>
                            <Pie
                                data={rangoEdades}
                                dataKey="value"
                                nameKey="name"
                                cx="50%"
                                cy="60%"
                                outerRadius={120}
                                fill="#82ca9d"
                                label={({ name, percent }) => `${(percent * 100).toFixed(2)}%`}
                            >
                                {rangoEdades.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                ))}
                            </Pie>
                            <Tooltip formatter={(value) => `${value}%`} />
                            <Legend 
                                layout="horizontal" 
                                verticalAlign="bottom" 
                                align="center" 
                                wrapperStyle={{ 
                                    position: "relative",  // Hace que "top" funcione
                                    top: "20px",  // Ajusta el valor para empujar la leyenda hacia abajo
                                    width: "90%", 
                                    textAlign: "center", 
                                    fontSize: '15px' 
                                }}
                            />

                        </PieChart>
                    </ResponsiveContainer>
                </div>

                <div className="chart-box " style={{flex: '1 1 45%', maxWidth: '45%', marginRight: '10px'}}>
                <h4 style={{ fontSize: '1.2rem' }}>Porcentaje por NIvel Instrucción</h4>
                    {nivelInstruccionOptions.length > 0 && (
                       <ResponsiveContainer width="100%" height={490}>
                                          {nivelesInstruccionData.length > 0 && (
                                                  <BarChart data={nivelesInstruccionData} margin={{ right: 30, left: -20 }}>
                                                      <CartesianGrid strokeDasharray="3 3" />
                                                      <XAxis dataKey="name" />
                                                      <YAxis />
                                                      <Tooltip />
                                                      <Legend />
                                                      <Bar dataKey="count" fill="#8884d8" name="Participantes" />
                                                  </BarChart>
                                              )}
                                          </ResponsiveContainer>
                    )}
                        

                </div>
               

                    {/* Modal de confirmación */}
                    <Modal show={showModalInfo} onHide={() => setShowModalInfo(false)} centered>
                    <Modal.Header closeButton>
                    <Modal.Title>Confirmar impresión</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                    ¿Está seguro que desea imprimir la información? Esto generará un archivo descargable en formato Excel.
                    </Modal.Body>
                    <Modal.Footer>
                    <div className="d-flex justify-content-end gap-2">
                        <Button variant="secondary" onClick={() => setShowModalInfo(false)}>
                            Cancelar
                        </Button>
                        <Button variant="primary" onClick={handlePrint}>
                            Imprimir
                        </Button>
                        </div>

                    </Modal.Footer>
                </Modal>
                 {/* Modal  de eliminación */}
                 <Modal show={showModal} onHide={handleCloseModal}>
                            <Modal.Header closeButton>
                                <Modal.Title>Confirmar eliminación</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>¿Estás seguro de que deseas eliminar este Participante y todos los datos relacionados a él?</Modal.Body>
                           
                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleCloseModal}>
                                    Cancelar
                                </Button>
                                <Button variant="danger" onClick={deleteDatos}>
                                    Eliminar
                                </Button>
                            </Modal.Footer>
                        </Modal>
   
                         
                          


                
                
                
                
            </div>
            
            



                            </motion.div>
             
                        

    </div>
    
                    

                );
};

export default ShowPartIniciativas;
